import React, { useMemo } from 'react';

import classNames from 'classnames';

import { PAGE_PADDING_CLASSES } from '../constants';
import KeyboardHints from '../KeyboardHints';
import { getKeyboardHints } from '../keyboard';
import Panel from '../Panel';
import WikiMeta from '../WikiMeta';

import LandingHeader from './LandingHeader';
import RecentlyViewed from './RecentlyViewed';
import SectionGrid from './SectionGrid';

const WikiLandingPage = () => {
  const hints = useMemo(() => getKeyboardHints(), []);

  return (
    <>
      <WikiMeta />
      <div className={classNames(PAGE_PADDING_CLASSES, 'mx-auto flex w-full max-w-6xl flex-col gap-8')}>
        <LandingHeader />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="flex min-w-0 flex-col gap-6 lg:col-span-2">
            <RecentlyViewed />
            <SectionGrid />
          </div>
          <div className="flex flex-col gap-6">
            <Panel title="Keyboard" titleId="wiki-keyboard-title">
              <KeyboardHints className="p-4" hints={hints} />
            </Panel>
            <Panel title="Something out of date?" titleId="wiki-feedback-title">
              <p className="p-4 paragraph-2 text-gray-700 dark:text-gray-300">
                Every wiki page has a feedback form at the bottom. Corrections are posted to #product-bugs.
              </p>
            </Panel>
          </div>
        </div>
      </div>
    </>
  );
};

export default WikiLandingPage;
